import type { AvailableInstallationDatesRequestItem as GeneratedAvailableInstallationDatesRequestItem } from '../../generated/api/availableInstallationDatesRequestItem.js';
import type { AvailableInstallationDatesResponseItem as GeneratedAvailableInstallationDatesResponseItem } from '../../generated/api/availableInstallationDatesResponseItem.js';
import type { AvailableTimeSlot as GeneratedAvailableTimeSlot } from '../../generated/api/availableTimeSlot.js';

export type AvailableInstallationDatesRequestItem = GeneratedAvailableInstallationDatesRequestItem;

export type AvailableTimeSlot = Omit<GeneratedAvailableTimeSlot, 'type'> & {
  // The OpenAPI wire property is @type, although the generated model exposes it as type.
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '@type': string;
};

export type AvailableInstallationDatesResponseItem = Omit<
  GeneratedAvailableInstallationDatesResponseItem,
  'availableTimeSlot'
> & {
  availableTimeSlot: AvailableTimeSlot[];
};

export enum InstallationAvailabilityStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  EMPTY = 'empty',
  ERROR = 'error',
}

export interface InstallationAvailabilityState {
  status: InstallationAvailabilityStatus;
  results: AvailableInstallationDatesResponseItem[];
  error?: string;
}
